class OmerellaShopByType extends HTMLElement {
  connectedCallback() {
    this.#tabs = [...this.querySelectorAll('.omerella-shop-by-type__tab')];
    this.#panels = [...this.querySelectorAll('.omerella-shop-by-type__panel')];

    this.#tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const panelId = tab.dataset.panel;
        if (!panelId) return;
        this.#activate(panelId);
      });
    });
  }

  /** @type {HTMLButtonElement[]} */
  #tabs = [];

  /** @type {HTMLElement[]} */
  #panels = [];

  /** @param {string} panelId */
  #activate(panelId) {
    this.#tabs.forEach((tab) => {
      const isActive = tab.dataset.panel === panelId;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.#panels.forEach((panel) => {
      const isActive = panel.dataset.panel === panelId;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }
}

if (!customElements.get('omerella-shop-by-type')) {
  customElements.define('omerella-shop-by-type', OmerellaShopByType);
}
